import React, { Component, Fragment } from 'react'
import styled, { css } from 'styled-components'
import { breakpoints, style } from 'app/assets/styles'
import { H2, H3, SmallText } from 'app/common/typography'
import { CircleMinus, CirclePlus } from 'app/assets/icons'
import Responsive from 'react-responsive'
import { Flip } from 'app/common/flip'

type Props = {
    title: string,
    date: string,
    story: string,
    index?: boolean,
    shadow: string,
    images: {
        mobile: string,
        desktop: string
    }
}

type State = {
    recto: boolean
}

class Tile extends Component<Props, State> {
    constructor() {
        super()
        this.state = {
            recto: true
        }
    }

    flip = () => this.setState({ recto: !this.state.recto })

    render() {
        const { recto } = this.state
        const { title, date, story, index, shadow, images } = this.props
        const breakpoint = breakpoints.medium

        const front = (
            <Fragment>
                <Title shadow={index ? shadow : ''} image={images.mobile}>
                    <StyledH3 color="white">{date}</StyledH3>
                    <StyledH2 color="white">{title}</StyledH2>
                </Title>
                <Button onClick={this.flip}>
                    <CirclePlus />
                </Button>
            </Fragment>
        )

        const back = (
            <Fragment>
                <Text>
                    <SmallText>{story}</SmallText>
                </Text>
                <Button onClick={this.flip}>
                    <CircleMinus />
                </Button>
            </Fragment>
        )

        return (
            <Fragment>
                <Responsive maxWidth={breakpoint - 1}>
                    <Flip
                        recto={recto}
                        front={front}
                        back={back}
                        minHeight={500}
                        className="timeline"
                    />
                </Responsive>
                <Responsive minWidth={breakpoint}>
                    <TitleDesktop shadow={shadow} image={images.mobile}>
                        <StyledH3 color={'white'}>{date}</StyledH3>
                        <StyledH2 color={'white'}>{title}</StyledH2>
                    </TitleDesktop>
                </Responsive>
            </Fragment>
        )
    }
}

const global = css`
    padding: 28px 40px;
    border-radius: 8px;
`

const title = css`
    background-image: url(${props => props.image});
    background-size: cover;
    box-shadow: ${props =>
        props.shadow ? `0 20px 30px 0 ${props.shadow}` : ''};
    ${global};
`

const Title = styled.div`
    ${title};
    height: 58vh;
    min-height: 400px;
`

const TitleDesktop = styled.div`
    ${title};
    position: absolute;
    top: 0;
    left: 0;
    height: 34vw;
    max-height: 490px;
    box-sizing: border-box;
`

const Text = styled.div`
    height: 58vh;
    min-height: 400px;
    ${global};
`

const StyledH2 = styled(H2)`
    margin: 5px 0;
`

const StyledH3 = styled(H3)`
    margin: 5px 0;
`

const Button = styled.button`
    position: absolute;
    bottom: 25px;
    right: 25px;
    padding: 5px;
    background: transparent;
    ${style.button};
`

export { Tile }
